if (!customElements.get('spazioil-early-access')) {
  customElements.define('spazioil-early-access', class extends HTMLElement {
    connectedCallback() {
      this.units = ['days', 'hours', 'minutes', 'seconds'];
      this.outputs = this.units.map(unit => this.querySelector(`[data-early-access-${unit}]`));
      this.bindSource = this.bindSource.bind(this);
      this.sync = this.sync.bind(this);
      this.observer = new MutationObserver(this.sync);
      document.addEventListener('shopify:section:load', this.bindSource);
      document.addEventListener('shopify:section:unload', this.bindSource);
      this.bindSource();
    }

    disconnectedCallback() {
      this.observer.disconnect();
      document.removeEventListener('shopify:section:load', this.bindSource);
      document.removeEventListener('shopify:section:unload', this.bindSource);
    }

    bindSource() {
      this.observer.disconnect();
      this.source = document.querySelector('.announcement-bar__countdown[data-countdown-type="scheduled"]');
      this.announcement = this.source?.closest('.section-announcement');
      if (this.announcement) {
        this.observer.observe(this.announcement, { childList: true, subtree: true, characterData: true, attributes: true });
      }
      this.sync();
    }

    sync() {
      const copy = this.announcement?.textContent || '';
      const values = this.units.map(unit => this.source?.querySelector(`[data-countdown-${unit}]`)?.textContent.trim());
      const valid = values.every(value => /^\d+$/.test(value || '')) && values.some(value => Number(value) > 0);
      const active = this.source?.isConnected &&
        this.source.dataset.countdownType === 'scheduled' &&
        !this.source.classList.contains('announcement-bar__countdown--hidden') &&
        /black\s*friday/i.test(copy) && /60\s*%\s*off/i.test(copy) && valid;
      this.hidden = !active;
      if (!active) return;
      this.outputs.forEach((output, index) => {
        if (output.textContent !== values[index]) output.textContent = values[index];
      });
    }
  });
}
